// extracted by mini-css-extract-plugin
export default {"video-item":"Video_video-item__0D0fZ","video-title-line":"Video_video-title-line__t8D4j","video-embed-container":"Video_video-embed-container__F+tuI"};